import * as Scrivito from "scrivito";
import React from "react";
import { Button } from "reactstrap";
import { show } from "@ebay/nice-modal-react";
import { ConfirmationModal } from "components";
import { MultipleProjectsDeleteMut } from "api/mutations";
import { useProjectDataStore } from "stores/projectStore";
import { useTranslate } from "hooks";
import { useAppBaseContext } from "providers";
import { useProjectListContext } from "../../hooks/useProjectListContext";

export const DeleteProjectsButton = Scrivito.connect(({ className }) => {
  const translate = useTranslate();
  const reset = useProjectDataStore((state) => state.reset);
  const {
    resetCallback,
    setProjectsToDelete,
    setIsSelectAll,
    refetchProjectList,
    resetUrlParams,
    currentPageNo,
    projectId,
    projects,
    projectsToDelete,
    setCurrentPageNo,
  } = useProjectListContext();
  const { lang: language } = useAppBaseContext();

  const handleProjectsDelete = () => {
    const projectsToDeleteList = projects
      .filter((proj) => projectsToDelete.includes(proj.id))
      .map((proj) => ({ id: proj.id, title: proj.title }));
    show(ConfirmationModal, {
      submitBtnText: translate("PROJECT_LIST_DELETE_PROJECTS"),
      title: translate("PROJECT_LIST_DELETE_PROJECTS"),
      alertText: translate("MULPIPLE_PROJECTS_MODAL_DELETE_WARNING_TEXT"),
      displayList: projectsToDeleteList,
      mutation: MultipleProjectsDeleteMut,
      params: { input: { ids: projectsToDelete, languageCode: language } },
    }).then(() => {
      // setTimeout is used for update projectList properly, due to DS-cache needs some time to update the data
      setTimeout(() => {
        setProjectsToDelete([]);
        setIsSelectAll(false);
        const page =
          projectsToDelete.length === projects.length && currentPageNo > 1
            ? String(currentPageNo - 1)
            : String(currentPageNo);
        setCurrentPageNo(Number(page));
        if (page > 1) {
          const url = new URL(window.location.href);
          url.searchParams.set("page", Number(page));
          window.history.replaceState({}, "", url);
        }
        refetchProjectList({
          variables: {
            page,
          },
          requestPolicy: "network-only",
        });

        if (projectId && projectsToDelete.includes(projectId)) {
          resetUrlParams();
        }
        reset();
        resetCallback();
      }, 2000);
    });
  };

  return (
    <div className={className}>
      <Button className="btn btn-secondary" onClick={handleProjectsDelete}>
        {translate("PROJECT_LIST_DELETE_PROJECTS")}
      </Button>
    </div>
  );
});
